// Example usage:
/*
const pagination = new PaginationHtml(
    0,
    3,
    'Seite {CURRENT_PAGE} von {PAGE_COUNT}',
    (pageNumber) => {
        const resultsPerPage = 25;
        return `?start=${pageNumber * resultsPerPage}`;
    }
);
*/

export default class PaginationHtml {
    /**
     * Constructor
     * @param {number} currentPage - Current page index (zero based)
     * @param {number} pageCount - Page Count (number of pages)
     * @param {string} labelTemplate - A string containing the
     * placeholders '{CURRENT_PAGE}' and '{PAGE_COUNT}'
     * which will be replaced with the given values.
     * @param {Function} hrefCallback - A callback function
     * which will be called for each rendered
     * pagination link with the page index as parameter.
     * The return value of this function will be used
     * for the links href attribute.
     */
    constructor(currentPage = 0, pageCount = 1, labelTemplate, hrefCallback) {
        this._currentPage = currentPage;
        this._pageCount = pageCount;
        this._labelTemplate = labelTemplate;
        this._hrefCallback = hrefCallback;
    }

    _createLabel() {
        return this._labelTemplate
            .replace('{CURRENT_PAGE}', this._currentPage + 1)
            .replace('{PAGE_COUNT}', this._pageCount);
    }

    _getButtonHtml(pageIndex, modifier) {
        let href = null;

        if (pageIndex >= 0 && pageIndex < this._pageCount && this._currentPage !== pageIndex) {
            href = this._hrefCallback(pageIndex);
        }

        const html = `
            <div class="rfct-pagination__button rfct-pagination__button--${modifier}${href ? '' : ' rfct-pagination__button--disabled'}">
                <a class="rfct-button rfct-button--secondary rfct-button--mini"${href ? ` href="${href}"` : ''}>
                    <span class="rfct-button__inner">
                        <span class="rfct-button__icon material-icons"></span>
                    </span>
                </a>
            </div>`;
        return html;
    }

    toString() {
        const html = `
        <div class="rfct-pagination">
            <div class="rfct-pagination__inner">
                <div class="rfct-pagination__controls rfct-pagination__controls--backwards">
                    ${this._getButtonHtml(0, 'first')}
                    ${this._getButtonHtml(this._currentPage - 1, 'prev')}
                </div>
                <div class="rfct-pagination__label">
                    <span class="rfct-pagination__label-text">
                        ${this._createLabel()}
                    </span>
                </div>
                <div class="rfct-pagination__controls rfct-pagination__controls--forwards">
                    ${this._getButtonHtml(this._currentPage + 1, 'next')}
                    ${this._getButtonHtml(this._pageCount - 1, 'last')}
                </div>
            </div>
        </div>`;

        return html;
    }
}
